import React from "react";
import * as S from "./styles";

import { usePolicemanRegister } from "contexts/register/PolicemanContext";

import Input from "../../../Input";
import MaskedInput from "../../../MaskedInput";

function VehicleForm({ updateVehicleData }: any) {
  const { vehicle, setVehicle, errors } = usePolicemanRegister();

  return (
    <S.Wrapper>
      <S.Form>
        <MaskedInput
          id="plate"
          name="plate"
          defaultValue={
            vehicle?.plate ? vehicle.plate : updateVehicleData?.plate
          }
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setVehicle((value) => {
              value.plate = event.target.value;
              return value;
            });
          }}
          label="Placa"
          required={true}
          type="text"
          mask="aaa-9*99"
          error={errors.plate || errors["vehicle.plate"]}
        />
        <Input
          id="brand"
          name="brand"
          defaultValue={
            vehicle.brand ? vehicle.brand : updateVehicleData?.brand
          }
          onChange={(event) =>
            setVehicle((value) => {
              value.brand = event.target.value;
              return value;
            })
          }
          label="Marca"
          required={true}
          type="text"
          error={errors.brand || errors["vehicle.brand"]}
        />
        <Input
          id="model"
          name="model"
          defaultValue={
            vehicle.model ? vehicle.model : updateVehicleData?.model
          }
          onChange={(event) =>
            setVehicle((value) => {
              value.model = event.target.value;
              return value;
            })
          }
          label="Modelo"
          required={true}
          type="text"
          error={errors.model || errors["vehicle.model"]}
        />
        <Input
          id="Cor"
          name="Cor"
          defaultValue={
            vehicle.color ? vehicle.color : updateVehicleData?.color
          }
          onChange={(event) =>
            setVehicle((value) => {
              value.color = event.target.value;
              return value;
            })
          }
          label="Cor"
          required={true}
          type="text"
          error={errors.color || errors["vehicle.color"]}
        />
        <Input
          id="characteristics"
          name="characteristics"
          defaultValue={
            vehicle.description
              ? vehicle.description
              : updateVehicleData?.description
          }
          onChange={(event) =>
            setVehicle((value) => {
              value.description = event.target.value;
              return value;
            })
          }
          label="Características adicionais"
          required={true}
          type="text"
          error={errors.description || errors["vehicle.description"]}
        />
      </S.Form>

    </S.Wrapper>
  );
}

export { VehicleForm };
